import { DashboardPage } from './DashboardPage';

export const dashboardRoutes = [
  {
    path: '',
    element: <DashboardPage />,
  },
];
